import { createDataHook } from 'next-data-hooks';

import { backend } from '../../utils/_config/axios';

export const useLanguageDependentDataSSr = <T>(basepath: string) =>
    createDataHook(basepath, async ({ locale }) => {
        const localeRes = !locale || locale === 'catchAll' ? 'en' : locale;
        return (await backend().get<T>(`api/strapi/${basepath}?_locale=${localeRes}`)).data;
    });
